// 第7张
const imgAll7 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304792/a7.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844699/c7.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304792/a7.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844699/c7.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092257150/a7.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092748308/b7.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093142669/uk7.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093605387/uk7.jpg',
    },
};
export const imgLocale7: any = {
    jp: imgAll7.JP,
    us: imgAll7.NA,
    ca: imgAll7.NA,
    br: imgAll7.NA,
    mx: imgAll7.NA,
    uk: imgAll7.UK,
    eu: imgAll7.EU,
    de: imgAll7.EU,
    fr: imgAll7.EU,
    it: imgAll7.EU,
    es: imgAll7.EU,
    nl: imgAll7.EU,
};
